import Layout from '@plat/views/event/attendee/confirmation/Layout'
import CancelForm from '@plat/views/event/attendee/confirmation/CancelForm'
import CancelMessage from '@plat/views/event/attendee/confirmation/CancelMessage'

export default [
  {
    path: '/',
    component: Layout,
    redirect: 'form',
    children: [{
      path: 'form',
      component: CancelForm,
      name: 'cancelForm'
    }, {
      path: 'success',
      component: CancelMessage,
      name: 'cancelConfirmed',
      props: true
    }, {
      path: 'decline',
      component: CancelMessage,
      name: 'cancelDeclined'
    }, {
      path: 'reject',
      component: CancelMessage,
      name: 'cancelReject'
    }]
  }
]
